import React from "react"

import classNames from "classnames/bind"
import styles from "../../styles/Question.module.scss"

class Gauge extends React.Component {
  componentDidMount() {
    // 0 ~ 11 : 총 12 Stage
    const currentIndex = this.props.currentIndex || 0

    // gauge bar의 전체 길이 - circle의 width
    let lineWidth = document.getElementById("gaugeLine").offsetWidth - 36

    // left값 재설정
    document.getElementById("gaugeCircle").style.left = (lineWidth * (currentIndex / 11)).toString() + "px"
  }

  componentDidUpdate(prevProps) {
    if (this.props.currentIndex !== prevProps.currentIndex) {
      // 0 ~ 11 : 총 12 Stage
      const currentIndex = this.props.currentIndex || 0

      // gauge bar의 전체 길이 - circle의 width
      let lineWidth = document.getElementById("gaugeLine").offsetWidth - 36

      // left값 재설정
      document.getElementById("gaugeCircle").style.left = (lineWidth * (currentIndex / 11)).toString() + "px"
    }
  }

  render() {
    const { currentIndex } = this.props

    return (
      <div className={cn("gauge")}>
        <div id="gaugeLine" className={cn("line")}></div>
        <div id="gaugeCircle" className={cn("circle-img")}>
          <span className={cn("number")}>{currentIndex + 1}</span>
        </div>
      </div>
    )
  }
}

const cn = classNames.bind(styles)

export default Gauge
